module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "approval-list-container"
  }, [(_vm.isBusy) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e(), _vm._v(" "), _c('b-card', {
    staticClass: "border-0 shadow-sm",
    staticStyle: {
      "border-radius": "8px",
      "overflow": "hidden"
    },
    attrs: {
      "no-body": ""
    }
  }, [_c('b-tabs', {
    attrs: {
      "card": "",
      "pills": ""
    },
    on: {
      "input": _vm.onTabChange
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "All"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Approved"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Pending"
    }
  }), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Rejected"
    }
  })], 1), _vm._v(" "), _c('b-card-header', {
    staticClass: "bg-white border-bottom p-0"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h4', {
    staticClass: "mb-0 text-primary font-weight-bold"
  }, [_c('i', {
    staticClass: "fa fa-check-circle mr-2"
  }), _vm._v("Credit / Debit Note Approvals\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-input-group', {
    staticClass: "mr-3",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('b-input-group-prepend', {
    staticClass: "bg-light border-right-0",
    attrs: {
      "is-text": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-search text-muted"
  })]), _vm._v(" "), _c('b-form-input', {
    staticClass: "border-left-0 bg-light",
    attrs: {
      "placeholder": "Search by Note ID, Series..."
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), (_vm.filter) ? _c('b-input-group-append', [_c('b-button', {
    staticClass: "text-muted",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "variant": "link"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.getData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Refresh\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-success",
      "disabled": _vm.isExporting
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [(_vm.isExporting) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export")])], 1), _vm._v(" "), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.filter-collapse",
      modifiers: {
        "filter-collapse": true
      }
    }],
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filters\n          ")])], 1)]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "filter-collapse"
    },
    model: {
      value: (_vm.filtersVisible),
      callback: function($$v) {
        _vm.filtersVisible = $$v
      },
      expression: "filtersVisible"
    }
  }, [_c('b-card', {
    staticClass: "bg-light border-0 mb-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Date Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.dateTypeOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Date Type"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.dateType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "dateType", $$v)
      },
      expression: "filters.dateType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    ref: "picker",
    staticClass: "w-100",
    attrs: {
      "opens": _vm.openLeft,
      "startDate": _vm.dateRange.startDate,
      "endDate": _vm.dateRange.endDate
    },
    on: {
      "update": _vm.onFilterChange
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(picker) {
        return [_c('div', {
          staticClass: "d-flex align-items-center form-control",
          staticStyle: {
            "min-width": "250px"
          }
        }, [_c('i', {
          staticClass: "fa fa-calendar mr-2 text-muted"
        }), _vm._v(" "), (picker.startDate && picker.endDate) ? _c('span', [_vm._v("\n                                      " + _vm._s(_vm.moment(picker.startDate).format('DD/MM/YYYY')) + " - " + _vm._s(_vm.moment(picker.endDate).format('DD/MM/YYYY')) + "\n                                  ")]) : _c('span', {
          staticClass: "text-muted"
        }, [_vm._v("Select Date Range")]), _vm._v(" "), _c('i', {
          staticClass: "fa fa-caret-down ml-auto text-muted"
        })])]
      }
    }]),
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "branchfilter", $$v)
      },
      expression: "filters.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Note Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.noteTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Note Type"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.noteType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "noteType", $$v)
      },
      expression: "filters.noteType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "clientFilter", $$v)
      },
      expression: "filters.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.slineFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "slineFilter", $$v)
      },
      expression: "filters.slineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("User")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select User"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.userFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "userFilter", $$v)
      },
      expression: "filters.userFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Agent/Coloader")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent/Coloader"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.agentFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "agentFilter", $$v)
      },
      expression: "filters.agentFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Consignee")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllConsigneeList'],
      "option-value": "agntColoaderId",
      "option-text": "consignee",
      "placeholder": "Select Consignee"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.consigneeFilter),
      callback: function($$v) {
        _vm.$set(_vm.filters, "consigneeFilter", $$v)
      },
      expression: "filters.consigneeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "small text-muted font-weight-bold"
  }, [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Transport Type"
    },
    on: {
      "input": _vm.onFilterChange
    },
    model: {
      value: (_vm.filters.transportType),
      callback: function($$v) {
        _vm.$set(_vm.filters, "transportType", $$v)
      },
      expression: "filters.transportType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "d-flex align-items-end mb-3",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm",
      "block": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-times mr-1"
  }), _vm._v(" Clear Filters\n                       ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card-body', {
    staticClass: "p-0"
  }, [_c('b-table', {
    staticClass: "mb-0 custom-table",
    attrs: {
      "items": _vm.items,
      "fields": _vm.fields,
      "responsive": "",
      "show-empty": "",
      "hover": "",
      "head-variant": "light"
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(row.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "NoteSeries",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [_c('div', [_c('strong', [_vm._v("Type:")]), _vm._v(" "), (row.item.NoteType) ? _c('b-badge', {
          attrs: {
            "variant": row.item.NoteType.toLowerCase().includes('credit') ? 'success' : 'danger'
          }
        }, [_vm._v("\n                              " + _vm._s(row.item.NoteType) + "\n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Series:")]), _vm._v(" "), (row.item.PdfLink) ? _c('a', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "text-primary font-weight-bold",
          attrs: {
            "href": "javascript:void(0)",
            "title": row.item.NoteSeries
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row.item.JobNo, row.item.PdfLink)
            }
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.truncateWithEllipsis(row.item.NoteSeries, 15)) + "\n                          ")]) : _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.NoteSeries
          }
        }, [_vm._v("\n                              " + _vm._s(_vm.truncateWithEllipsis(row.item.NoteSeries, 15)) + "\n                          ")])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(row.item.NoteDate))]), _vm._v(" "), (row.item.ContainerTypesArr) ? _c('div', [_c('strong', [_vm._v("Container:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.ContainerTypesArr
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.ContainerTypesArr, 20)))])]) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("By:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.NoteCreatedBy, 15)))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_vm._v(_vm._s(row.item.NoteCreatedTime))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_vm._v(_vm._s(row.item.NoteCreatedTime))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Approved By:")]), _vm._v(_vm._s(row.item.ApprovedBy))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Approved Date:")]), _vm._v(_vm._s(row.item.ApprovedDate))])])]
      }
    }, {
      key: "NoteAmount",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [_c('div', {
          staticClass: "text-nowrap"
        }, [_c('strong', [_vm._v("Amt:")]), _vm._v(" "), _c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v(_vm._s(row.item.Currency))]), _vm._v(" " + _vm._s(row.item.NoteAmount))]), _vm._v(" "), (row.item.NoteContent) ? _c('div', [_c('strong', [_vm._v("Content:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.NoteContent
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.NoteContent, 20)))])]) : _vm._e(), _vm._v(" "), (row.item.BLNumber) ? _c('div', [_c('strong', [_vm._v("HBL:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.BLNumber
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.BLNumber, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.MasterorLinerBlNo) ? _c('div', [_c('strong', [_vm._v("MBL:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.MasterorLinerBlNo
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.MasterorLinerBlNo, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.ValidBookingNo) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Booking:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.ValidBookingNo, 15)))]) : _vm._e()])]
      }
    }, {
      key: "SalesSeries",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [_c('div', [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.JobType, 15)))]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("No:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.JobNo
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.JobNo, 15)))])]), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Date:")]), _vm._v(" " + _vm._s(row.item.JobDate))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("By:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.JobRaisedBy, 15)))]), _vm._v(" "), _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("From:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.JobRaisedFrom, 15)))]), _vm._v(" "), (row.item.VesselVoyage) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Vessel:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.VesselVoyage, 15)))]) : _vm._e()])]
      }
    }, {
      key: "ApprovalStatus",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content status-column"
        }, [_c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("Approval:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.ApprovalStatus)
          }
        }, [_vm._v(_vm._s(row.item.ApprovalStatus))])], 1), _vm._v(" "), _c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("Billing:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.BillingStatus)
          }
        }, [_vm._v(_vm._s(row.item.BillingStatus))])], 1), _vm._v(" "), _c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("TPT Inv:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.TptInvoiceClosed)
          }
        }, [_vm._v(_vm._s(row.item.TptInvoiceClosed))])], 1), _vm._v(" "), _c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("CC Inv:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.CcInvoiceClosed)
          }
        }, [_vm._v(_vm._s(row.item.CcInvoiceClosed))])], 1), _vm._v(" "), _c('div', {
          staticClass: "mb-1"
        }, [_c('strong', [_vm._v("FF Inv:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.CfInvoiceClosed)
          }
        }, [_vm._v(_vm._s(row.item.CfInvoiceClosed))])], 1), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Prealert:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.PrealertStatus)
          }
        }, [_vm._v(_vm._s(row.item.PrealertStatus))])], 1), _vm._v(" "), (row.item.PrealertDate) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Prealert Date:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.PrealertDate, 15)))]) : _vm._e(), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Manifest:")]), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.ManifestStatus)
          }
        }, [_vm._v(_vm._s(row.item.ManifestStatus))])], 1), _vm._v(" "), (row.item.ManifestDate) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Manifest Date:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.ManifestDate, 15)))]) : _vm._e()])]
      }
    }, {
      key: "AgentColoader",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [(row.item.AgentType) ? _c('div', [_c('strong', [_vm._v("Type:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.AgentType, 15)))]) : _vm._e(), _vm._v(" "), (row.item.AgentColoader) ? _c('div', [_c('strong', [_vm._v("Agent:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.AgentColoader
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.AgentColoader, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.Shipper) ? _c('div', [_c('strong', [_vm._v("Shipper:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.Shipper
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.Shipper, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.Consignee) ? _c('div', [_c('strong', [_vm._v("Consignee:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.Consignee
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.Consignee, 15)))])]) : _vm._e()])]
      }
    }, {
      key: "Shipper",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [(row.item.Client) ? _c('div', [_c('strong', [_vm._v("Client:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.Client
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.Client, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.Sline) ? _c('div', [_c('strong', [_vm._v("Sline:")]), _vm._v(" "), _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          attrs: {
            "title": row.item.Sline
          }
        }, [_vm._v(_vm._s(_vm.truncateWithEllipsis(row.item.Sline, 15)))])]) : _vm._e(), _vm._v(" "), (row.item.Por) ? _c('div', [_c('strong', [_vm._v("POR:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.Por, 12)))]) : _vm._e(), _vm._v(" "), (row.item.Pol) ? _c('div', [_c('strong', [_vm._v("POL:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.Pol, 12)))]) : _vm._e(), _vm._v(" "), (row.item.Pod) ? _c('div', [_c('strong', [_vm._v("POD:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.Pod, 12)))]) : _vm._e(), _vm._v(" "), (row.item.Fpod) ? _c('div', [_c('strong', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.Fpod, 12)))]) : _vm._e()])]
      }
    }, {
      key: "ETADest",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [(row.item.ETADest) ? _c('div', [_c('strong', [_vm._v("ETA:")]), _vm._v(" " + _vm._s(row.item.ETADest))]) : _vm._e(), _vm._v(" "), (row.item.SobDate) ? _c('div', [_c('strong', [_vm._v("SOB:")]), _vm._v(" " + _vm._s(row.item.SobDate))]) : _vm._e(), _vm._v(" "), (row.item.EtaDestActual) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("ETA Actual:")]), _vm._v(" " + _vm._s(row.item.EtaDestActual))]) : _vm._e(), _vm._v(" "), (row.item.EtaDestEst) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("ETA Est:")]), _vm._v(" " + _vm._s(row.item.EtaDestEst))]) : _vm._e(), _vm._v(" "), (row.item.MblReleaseDate) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("MBL Release:")]), _vm._v(" " + _vm._s(row.item.MblReleaseDate))]) : _vm._e(), _vm._v(" "), (row.item.MblDate) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(row.item.MblDate))]) : _vm._e()])]
      }
    }, {
      key: "VesselVoy",
      fn: function(row) {
        return [_c('div', {
          staticClass: "cell-content"
        }, [(row.item.BillingType) ? _c('div', [_c('strong', [_vm._v("Billing:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.BillingType, 12)))]) : _vm._e(), _vm._v(" "), (row.item.BLType) ? _c('div', [_c('strong', [_vm._v("BL Type:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.BLType, 12)))]) : _vm._e(), _vm._v(" "), (row.item.FrghtTermsHbl) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("HBL:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.FrghtTermsHbl, 12)))]) : _vm._e(), _vm._v(" "), (row.item.FrghtTermsMbl) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("MBL:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.FrghtTermsMbl, 12)))]) : _vm._e(), _vm._v(" "), (row.item.FrghtTermsLiner) ? _c('div', {
          staticClass: "text-muted small"
        }, [_c('strong', [_vm._v("Liner:")]), _vm._v(" " + _vm._s(_vm.truncateWithEllipsis(row.item.FrghtTermsLiner, 12)))]) : _vm._e()])]
      }
    }, {
      key: "ContainerTypesArr",
      fn: function(row) {
        return undefined
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [_c('div', {
          staticClass: "d-flex flex-column"
        }, [_c('div', {
          staticClass: "d-flex align-items-center mb-1"
        }, [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "outline-info",
            "title": "Summary & Documents"
          },
          on: {
            "click": function($event) {
              _vm.openModal('doc', row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        })]), _vm._v(" "), _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "info",
            "title": "View Details"
          },
          on: {
            "click": function($event) {
              _vm.openViewModal(row.item)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-eye text-white"
        })]), _vm._v(" "), (row.item.note_id && _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('EditCRDRNote', {
          staticClass: "mr-1",
          attrs: {
            "title": 'Edit ' + (row.item.NoteType && row.item.NoteType.toLowerCase().includes('credit') ? 'Credit' : 'Debit') + ' Note : ' + row.item.NoteSeries,
            "note_id": String(row.item.note_id),
            "noteSeries": row.item.NoteSeries,
            "note_page": row.item.Page ? row.item.Page.toLowerCase() : '',
            "AgentType": row.item.AgentType,
            "creditDebitNoteType": row.item.NoteType && row.item.NoteType.toLowerCase().includes('credit') ? '1' : '2',
            "approvalStatus": row.item.ApprovalStatus === 'Approved' ? '1' : '0',
            "uploadCreditDebit": row.item.PdfLink || '',
            "creditDebitNote_Status": row.item.ApprovalStatus === 'Approved' ? '1' : '0',
            "JOBID": String(row.item.JobId || row.item.allModuleId),
            "JOBNO": row.item.JobNo,
            "JOBDATE": row.item.JobDate,
            "JOBTYPE": row.item.JobType,
            "isIcon": true
          }
        }) : _vm._e(), _vm._v(" "), (row.item.PdfLink) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "warning",
            "title": "View Note PDF"
          },
          on: {
            "click": function($event) {
              _vm.PrintNote(row.item.JobNo, row.item.PdfLink)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-pdf-o text-white"
        })]) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('JobWisePaymentsDetails', {
          attrs: {
            "allModuleId": Number(row.item.JobId),
            "JobNo": row.item.JobNo,
            "isIcon": true,
            "iconClass": "fa fa-money"
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('AssignmentSummary', {
          attrs: {
            "title": 'Shipment Summary Tracking',
            "assign_date": _vm.moment(row.item.NoteCreatedTime).format('DD/MM/YYYY'),
            "assign_job_type": row.item.JobType || '',
            "assign_raised_from": 'Raised From: ' + (row.item.BranchName || ''),
            "assign_raised_by": 'Raised By: ' + (row.item.NoteCreatedBy || ''),
            "fk_all_module_id": row.item.JobId,
            "jb_series": row.item.JobNo,
            "fk_client_id": '',
            "fk_pod_id": '',
            "isIcon": true,
            "iconClass": "fa fa-truck"
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [(row.item.JobId) ? _c('InvExpSummary', {
          attrs: {
            "PMC_title": 'Inv Exp Summary Note - ' + row.item.JobNo,
            "PMC_JOBID": String(row.item.JobId),
            "PMC_JOBNO": row.item.JobNo,
            "PMC_JOBDATE": _vm.moment(row.item.NoteCreatedTime).format('DD/MM/YYYY'),
            "PMC_JOBTYPE": row.item.JobType || '',
            "PMC_AgentType": '',
            "PMC_Client": row.item.AgentColoader || '',
            "PMC_Sline": row.item.shippingLine || '',
            "isIcon": true,
            "iconClass": "fa fa-list-alt"
          }
        }) : _vm._e(), _vm._v(" "), (row.item.JobId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Note - ' + row.item.JobNo,
            "PMC_JOBID": String(row.item.JobId),
            "PMC_JOBNO": row.item.JobNo,
            "PMC_JOBDATE": _vm.moment(row.item.NoteCreatedTime).format('DD/MM/YYYY'),
            "PMC_JOBTYPE": row.item.JobType || '',
            "PMC_AgentType": '',
            "PMC_Client": row.item.AgentColoader || '',
            "PMC_Sline": row.item.shippingLine || '',
            "isIcon": true,
            "iconClass": "fa fa-cube"
          }
        }) : _vm._e(), _vm._v(" "), (row.item.ApprovalStatus === 'Pending' && !row.item.PdfLink) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "mr-1 btn-action",
          attrs: {
            "size": "sm",
            "variant": "outline-success",
            "title": "Approve"
          },
          on: {
            "click": function($event) {
              _vm.approve(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-check"
        })]) : _vm._e(), _vm._v(" "), (row.item.ApprovalStatus === 'Pending' && !row.item.PdfLink) ? _c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          staticClass: "btn-action",
          attrs: {
            "size": "sm",
            "variant": "outline-danger",
            "title": "Reject"
          },
          on: {
            "click": function($event) {
              _vm.reject(row.item, row.index)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-times"
        })]) : _vm._e(), _c('br'), _vm._v(" "), _c('b-badge', {
          staticClass: "badge-sm",
          attrs: {
            "variant": _vm.getStatusVariant(row.item.ApprovalStatus)
          }
        }, [_vm._v("\n                              " + _vm._s(row.item.ApprovalStatus) + "\n                          ")])], 1)])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-5"
  }, [_c('i', {
    staticClass: "fa fa-inbox fa-3x mb-3"
  }), _vm._v(" "), _c('p', [_vm._v("No records found.")])])])], 2)], 1), _vm._v(" "), _c('b-card-footer', {
    staticClass: "bg-white border-top py-3"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('div', {
    staticClass: "text-muted small"
  }, [_vm._v("\n               Showing " + _vm._s(_vm.items.length > 0 ? (_vm.currentPage - 1) * _vm.perPage + 1 : 0) + " to " + _vm._s(Math.min(_vm.currentPage * _vm.perPage, _vm.totalRows)) + " of " + _vm._s(_vm.totalRows) + " entries\n           ")]), _vm._v(" "), _c('b-pagination', {
    staticClass: "mb-0 custom-pagination",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "right",
      "pills": ""
    },
    on: {
      "change": _vm.onPageChange
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "visible": _vm.activeModal === 'doc',
      "size": "xl",
      "hide-footer": "",
      "title": "Summary & Documents"
    },
    on: {
      "hidden": function($event) {
        _vm.activeModal = null
      }
    }
  }, [(_vm.selectedItem && _vm.activeModal === 'doc') ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.selectedItem.JobId,
      "JOBSERIES": _vm.selectedItem.JobNo
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('view-note-details-modal', {
    ref: "viewModal"
  }), _vm._v(" "), _c('b-modal', {
    ref: "common-note-modal",
    attrs: {
      "id": "confirm-modal",
      "title": _vm.confirmTitle,
      "ok-variant": _vm.confirmVariant,
      "ok-title": "YES",
      "cancel-title": "NO",
      "centered": "",
      "size": "sm"
    },
    on: {
      "ok": _vm.handleConfirm
    }
  }, [_c('p', {
    staticClass: "my-4"
  }, [_vm._v(_vm._s(_vm.confirmMessage))])]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e419305","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/creditDebitNote/ApprovalList.vue
// module id = 2614
// module chunks = 0